import { render, staticRenderFns } from "./AppSettingsPopup.vue?vue&type=template&id=b589db02&scoped=true&"
import script from "./AppSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./AppSettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsPopup.vue?vue&type=style&index=0&id=b589db02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b589db02",
  null
  
)

export default component.exports